// Window events the shell listens to, so any page can open its overlays.
export const OPEN_SEARCH_EVENT = 'cortex:open-search';
export const START_TUTORIAL_EVENT = 'cortex:start-tutorial';

export const openSearch = () => window.dispatchEvent(new CustomEvent(OPEN_SEARCH_EVENT));
